<template>
  <el-tag size="" v-if="item.del != 0">{{item.tag_name}}</el-tag>
</template>
<script>
export default {
  props: {
    item: Object
  }
}
</script>
<style lang="scss" scoped>
  @import './index.scss';
</style>



// WEBPACK FOOTER //
// src/components/Tag/index.vue